import React from 'react'
import styles from '../../styles/TryBuildbox.module.scss'
import {  useHistory } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import currentUserInfo from '../../selectors/currentUserInfo';
import { PlanIds, ProductType } from '../../reducers/models';
import { addPlanToCart } from '../../actions/cart';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindows } from "@fortawesome/free-brands-svg-icons/faWindows";
import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";

import { downloadBuildboxClient } from "../../utils/downloadsUtils";
import { DownloadPlatforms } from "../../reducers/models";
import PLANS_JSON from '../../constants/planMetadata';

export interface TryBuildboxProps {
  showText: boolean
  planId: PlanIds
}

const TryBuildbox = ({showText, planId}: TryBuildboxProps) => {

  const subscriptionPlan: bb.model.ISubscription = PLANS_JSON[planId];
  const currentUser = useSelector(currentUserInfo)
  const history = useHistory()
  const dispatch = useDispatch()

  function handlePurchaseClick(): void {
    dispatch(addPlanToCart(planId));

    const promoCode = sessionStorage.getItem("promoCode");
    if (currentUser?.referralInfo?.Network?.toLowerCase() === "xsolla") {
      if (promoCode) {
        history.push(`/purchaseThroughXsolla?promo=${promoCode}`);
      } else {
        history.push("/purchaseThroughXsolla");
      }
    } else {
      if (promoCode) {
        history.push(`/purchaseThroughStripeCheckout?promo=${promoCode}`);
      } else {
        history.push("/purchaseThroughStripeCheckout");
      }
    }
  }

  function handleMacDownloadClick() {
    if (subscriptionPlan.productType === ProductType.BB2) {
      downloadBuildboxClient(DownloadPlatforms.MAC, "BB2");
    }
    else {
      downloadBuildboxClient(DownloadPlatforms.MAC, "BB4");
    }
  }

  function handleWindowsDownloadClick() {
    if (subscriptionPlan.productType === ProductType.BB2) {
      downloadBuildboxClient(DownloadPlatforms.WINDOWS, "BB2");
    }
    else {
      downloadBuildboxClient(DownloadPlatforms.WINDOWS, "BB4");
    }
  }
  
  function getButtons() {
    if (isMobile) {
      return (<></>)
    }
    else {
      return (
        <div className={styles.buttonDownloadRow}>
          <button className={styles.buttonDownloadBB4} onClick={handleWindowsDownloadClick}>
            <FontAwesomeIcon className={styles.checkIcon} icon={faWindows} size={"3x"}/>
            <div>
              <div>Download</div>
              <div>for Windows</div> 
            </div>
          </button>
          <button className={styles.buttonDownloadBB4} onClick={handleMacDownloadClick}>
            <FontAwesomeIcon className={styles.checkIcon} icon={faApple} size={"3x"}/>
            <div>
              <div>Download</div>
              <div>for Mac</div> 
            </div>
          </button>
        </div>
      )
    }
  }

  return (
    <div className={styles.container}>
        <>
        <div className={styles.content}>
              {showText && <><div>
                <h1>Make games with AI - Just type a quick prompt,</h1>
              </div>
                <div>
                  <h1>and watch your ideas come to life!</h1>
                </div></>}
          <div >
            <button className={styles.buttonNewBB4Home} onClick={handlePurchaseClick}>
              START TODAY!
            </button>
            {getButtons()}
          </div>
        </div>
      </>
    </div>
  )
}

export default TryBuildbox
